import { useEffect, useState } from 'react';

export const useMediaDevice = () => {
    // 是否已经初始化
    const [isInit, setIsInit] = useState(false);
    const [isH5, setIsH5] = useState(false);
    const [isPad, setIsPad] = useState(false);
    const [isDesktop, setIsDesktop] = useState(false);
    const [isPC, setIsPC] = useState(true);
    const handleResize = () => {
        if (typeof window === 'undefined') return;
        setIsInit(true);
        setIsH5(window.innerWidth < 768);
        setIsPad(window.innerWidth >= 768 && window.innerWidth <= 1024);
        setIsDesktop(window.innerWidth > 1024 && window.innerWidth <= 1440);
        setIsPC(window.innerWidth > 1440);
    };
    useEffect(() => {
        if (typeof window === 'undefined') return;
        handleResize();
        // resize事件会在手机端拉起软键盘时频繁触发，不建议这里监听
        // window.addEventListener('resize', handleResize);
        // return () => {
        //     window.removeEventListener('resize', handleResize);
        // };
    }, []);

    return {
        isInit,
        isH5,
        isPad,
        isPC,
        isDesktop,
    };
};
